import { Grid, Link, Stack } from "@mui/material";
import useResponsive from "../../../hooks/minimal/useResponsive.jsx";
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';
import { useSettingsContext } from "../../../components/minimal/settings/SettingsContext.jsx";
import { useSearchParams } from "react-router-dom";
import { isInIframe } from "../../../utils/iframe";
const defaultBg = 'url(/assets/background/overlay_3.jpg)'


// this function is used to inject custom css from the parent website when the view is rendered in an iframe
// it is used to customize the view theme 
const injectCustomCss = () => {
    // listen to the parent window 'custom-css' post message
    window.addEventListener('message', (event) => {
        if (event.data.type === 'custom-css') {
            window.removeEventListener('click', this); // remove the listener
            const css = event.data.payload
            const style = document.createElement('style')
            style.innerHTML = css
            document.head.appendChild(style)
            // send back a message to confirm the css was updated
            window.parent.postMessage({ type: 'custom-css-applied' }, '*')
        }
    })
}

if (isInIframe()) {
    injectCustomCss()
}

// this component is used to render views in an iframe embedded in another website
// and allows to customize the view theme to the parent website theme
export const IFrameView = ({ children }) => {
    const isDesktop = useResponsive('up', 'md');
    const { presetsColor } = useSettingsContext();
    const [searchParams, setSearchParams] = useSearchParams();

    const params = Object.fromEntries(searchParams.entries())
    const { backgroundColor, primaryColor, infoColor, fontFamily, borderRadius, btnBorderRadius, fontUrl, boldFontUrl } = params
    let theme = useTheme()
    // if the no style params are provided, render the view with the default theme
    const noStyleParams = !backgroundColor && !primaryColor && !fontFamily && !borderRadius && !btnBorderRadius && !fontUrl && !boldFontUrl && !infoColor
    if (noStyleParams) {
        return <>{children}</>
    }
    theme = createTheme({
        ...theme,
        typography: {
            fontFamily: fontFamily || theme.typography.fontFamily
        },
        shape: {
            borderRadius: borderRadius || theme.shape.borderRadius
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontWeight: 'bold',
                        borderRadius: btnBorderRadius || theme.shape.borderRadius
                    }
                }
            }
        },
        palette: {
            primary: theme.palette.augmentColor({
                color: {
                    main: primaryColor || presetsColor.main,
                },
                name: 'primary',
            }),
            info: theme.palette.augmentColor({
                color: {
                    main: infoColor || theme.palette.info.main,
                },
                name: 'info',
            })
        }
    });
    const loadFont = fontUrl && fontFamily


    return (
        <ThemeProvider theme={theme}>
            {loadFont && <style >
                {`
                    @font-face {
                        font-family: ${fontFamily};
                        src: url('${fontUrl}');
                        font-weight: normal;
                        font-style: normal;
                    }
                    @font-face {
                        font-family: ${fontFamily};
                        src: url('${boldFontUrl || fontUrl}');
                        font-weight: bold;
                        font-style: normal;
                    }
                `}
            </style>}
            <GlobalStyles styles={{ body: { backgroundColor: backgroundColor || defaultBg } }} />
            <Grid
                justifyContent="center"
                container
                translate="no"
                className="notranslate"
                sx={{
                    p: isDesktop ? 8 : 0,
                    minHeight: "100vh",
                    backgroundImage: backgroundColor || defaultBg,
                    backgroundAttachment: "fixed",
                    backgroundPosition: 'center',
                    backgroundSize: 'cover'
                }}>
                <Stack spacing={2} sx={{ maxWidth: "1000px", minWidth: isDesktop ? "600px" : "0px" }}>
                    {children}
                </Stack>
            </Grid>
        </ThemeProvider>
    )
}
